import _get from 'lodash/get'

import axios from '../../_framework/axios/trip-dashboard-axios'

const packingInformationSectionName = 'packing_information'

export default {
  state: {
    Templates: _get(window, 'appInitialData.stores.PackingInformationTemplates', [])
  },
  getters: {
    PackingInformationTemplates: state => {
      return state.Templates
    }
  },
  mutations: {
    updatePackingInformationTemplates(state, payload) {
      state.Templates = payload.templates
    }
  },
  actions: {
    getPackingInformationTemplates(context) {
      axios.get('/getTravelInfoTemplates/packing_information').then(response => {
        if (response.status === 200) {
          context.commit('updatePackingInformationTemplates', response.data)
        }
      })
    },
    addPackingInformationTemplate(context, payload) {
      payload.section = packingInformationSectionName
      axios.post('/addTravelInfoTemplate', payload).then(response => {
        if (response.status === 200) {
          context.commit('updatePackingInformationTemplates', response.data)
        }
      })
    },
    updatePackingInformationTemplate(context, payload) {
      payload.section = packingInformationSectionName
      axios.post(`/updateTravelInfoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updatePackingInformationTemplates', response.data)
        }
      })
    },
    removePackingInformationTemplate(context, payload) {
      payload.section = packingInformationSectionName
      axios.post(`/removeTravelInfoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updatePackingInformationTemplates', response.data)
        }
      })
    },
    importPackingInformationTemplate(context, payload) {
      payload.section = packingInformationSectionName
      return new Promise(resolve => {
        axios
          .post(
            `${context.getters.currentTripDashboardId}/importTravelInfoTemplate/${payload.template.id}`,
            payload
          )
          .then(response => {
            if (response.status === 200) {
              context.commit('updateStore', {
                store: 'packing_information',
                value: response.data.packing_information
              })
              resolve()
            }
          })
      })
    }
  }
}
